import { motion } from 'framer-motion';
import { Button } from '@/components/Button';
import { useRouter } from 'next/router';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';

export default function Contact() {
  const router = useRouter();
  const t = useTranslations('contact');

  const contactMethod = {
    icon: EnvelopeIcon,
    title: t('contactCard.title'),
    value: t('contactCard.value'),
    action: 'mailto:contact@afivio.com'
  };

  return (
      <>
        <div className="bg-gradient-to-b from-gray-50 to-white">
          <section className="pt-28 pb-20 px-6">
            <div className="max-w-7xl mx-auto text-center">
              <motion.h1
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text text-transparent mb-6"
              >
                {t('hero.title')}
              </motion.h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                {t('hero.subtitle')}
              </p>
            </div>
          </section>

          {/* Single Contact Card */}
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="flex justify-center">
                <motion.a
                    href={contactMethod.action}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ y: -5 }}
                    className="p-10 border rounded-2xl hover:border-blue-100 hover:shadow-lg transition-all w-full max-w-xl text-center"
                >
                  <contactMethod.icon className="w-20 h-20 text-blue-600 mb-6 mx-auto" />
                  <h3 className="text-2xl font-semibold mb-2">{contactMethod.title}</h3>
                  <p className="text-gray-600 mb-6">{contactMethod.value}</p>

                  {/* Additional info */}
                  <div className="mt-8 pt-6 border-t border-gray-100">
                    <p className="text-gray-500 italic">
                      {t('contactCard.extra')}
                    </p>
                  </div>
                </motion.a>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-24">
            <div className="max-w-4xl mx-auto px-6 text-center">
              <motion.div
                  initial={{ scale: 0.95 }}
                  whileInView={{ scale: 1 }}
                  className="bg-gradient-to-r from-blue-600 to-green-500 p-12 rounded-3xl text-white"
              >
                <h2 className="text-4xl font-bold mb-6">{t('cta.title')}</h2>
                <div className="flex justify-center gap-4 mt-8">
                  <Button green onClick={() => router.push('/signup')}>
                    {t('cta.business')}
                  </Button>
                  <Button blue onClick={() => router.push('/signin')}>
                    {t('cta.creator')}
                  </Button>
                </div>
              </motion.div>
            </div>
          </section>
        </div>
      </>
  );
}